import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class highlightsProductsService {
  private highlightsProducts = new BehaviorSubject<any>(null);
  constructor() {}

  setHighlightsProducts(data: any) {
    this.highlightsProducts.next(data);
  }
  getHighlightsProducts(): Observable<any> {
    // return this.videoProducts;
    return this.highlightsProducts.asObservable();
  }
}
